import React, { useEffect, useState } from "react";
import { Table, Button, Form } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import moment from "moment";
import { form26QFields, getGridColumnTotal } from "../../utils/client/misc";

const Form26QTable = ({
  data = [],
  onEdit = () => {},
  // onDelete,
  activePage,
  limit,
  setEmpIds = () => {},
  selectedMonth,
  isDataSendToCA,
  empIds = [],
}) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  let totalAmountPaid = 0;
  let totalTDSAmount = 0;
  let totalINTT = 0;
  let totalTax = 0;

  totalAmountPaid = getGridColumnTotal(data, activePage, limit, "ap");
  totalTDSAmount = getGridColumnTotal(data, activePage, limit, "ta");
  totalINTT = getGridColumnTotal(data, activePage, limit, "it");
  totalTax = getGridColumnTotal(data, activePage, limit, "tt");

  useEffect(() => {
    if (selectedMonth) {
      setSelectedIds([]);
      setEmpIds([]);
    }
  }, [selectedMonth]);

  // Select All checkbox
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      const allIds = data
        ?.slice((activePage - 1) * limit, activePage * limit)
        .map((row) => row.id);
      setSelectedIds(allIds);
      setEmpIds(allIds);
    } else {
      setSelectedIds([]);
      setEmpIds([]);
    }
  };

  useEffect(() => {
    if (empIds?.length == 0) {
      setSelectAll(false);
    } else {
      setSelectAll(true);
    }
  }, [empIds]);

  const handleCheckboxChange = (e, id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
    setEmpIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <Table striped bordered hover className="w-100 custom-table-form24 ">
      <thead className="table-light">
        <tr>
          <th className="sticky-col col-1 sno" style={{ width: "50px" }}>
            SNo
          </th>
          <th className="sticky-col col-1" style={{ width: "50px" }}>
            {/* <FaTrash
              style={{
                color: "#2c3e50",
                fontSize: "0.8rem",
                cursor: "default",
              }}
            /> */}
            <Form.Group>
              <Form.Check
                type="checkbox"
                disabled={isDataSendToCA}
                checked={selectAll}
                onChange={handleSelectAll}
                // tabIndex={info?.tab}
                className="text-primary"
              />
            </Form.Group>
          </th>
          <th
            className="sticky-col col-2"
            style={{ width: "100px", textAlign: "center" }}
          >
            Action
          </th>
          {form26QFields.map((col) => (
            <th style={{ width: col.width }} className={col.className || ""}>
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data
          ?.slice((activePage - 1) * limit, activePage * limit)
          .map((info, index) => (
            <tr key={index}>
              <td className="sticky-col col-1 text-center sno">
                {index + 1 + limit * (activePage - 1)}
              </td>
              <td className="sticky-col col-1 text-center">
                {/* <FaTrash
                  style={{
                    color: "#2c3e50",
                    fontSize: "0.80rem",
                    cursor: "pointer",
                  }}
                  onClick={() => onDelete(info?.id)}
                /> */}
                <Form.Group>
                  <Form.Check
                    type="checkbox"
                    disabled={isDataSendToCA}
                    checked={selectedIds.includes(info?.id)}
                    onChange={(e) => handleCheckboxChange(e, info?.id)}
                    // tabIndex={info?.tab}
                    className="text-primary"
                  />
                </Form.Group>
              </td>
              <td className="sticky-col col-2 text-center">
                <Button variant="link" onClick={() => onEdit(info)}>
                  <FaEdit
                    style={{
                      cursor: "pointer",
                      color: "#2c3e50",
                    }}
                  />
                </Button>
              </td>
              {form26QFields.map((col) => (
                <td key={col.key} className={col.className || ""}>
                  {col.key === "apd"
                    ? info?.apd && moment(info.apd).format("DD-MM-YYYY")
                    : col.key === "chdt"
                    ? info?.chdt && moment(info.chdt).format("DD-MM-YYYY")
                    : info?.[col.key] ?? ""}
                </td>
              ))}
            </tr>
          ))}
        {
          data.map((info, index) => (
            <tr key={index}>
              <td className="sticky-col col-1 text-center"></td>
              <td className="sticky-col col-1 text-center"></td>
              <td className="sticky-col col-2 text-center"></td>
              {form26QFields.map((col) => (
                <td
                  key={col.key}
                  style={{ fontWeight: "bold" }}
                  className={col.className || ""}
                >
                  {col.key === "na"
                    ? "TOTAL"
                    : col.key === "pa" ||
                      col.key === "ad" ||
                      col.key === "pi" ||
                      col.key === "np" ||
                      col.key === "apd" ||
                      col.key === "rt" ||
                      col.key === "cn" ||
                      col.key === "tdbn"
                    ? ""
                    : col.key === "ap"
                    ? totalAmountPaid
                    : col.key === "ta"
                    ? totalTDSAmount
                    : col.key === "it"
                    ? totalINTT
                    : col.key === "tt"
                    ? totalTax
                    : ""}
                </td>
              ))}
            </tr>
          ))[0]
        }
      </tbody>
    </Table>
  );
};
export default Form26QTable;
